import moment from 'moment';

export function calculateRepaymentDate(selectedDay, currentDate = moment().format('DD-MM-YYYY')) {
  const today = moment(currentDate, 'DD-MM-YYYY');

  const oneMonthFromSelectedDay = moment(today).date(selectedDay).add(1, 'month');

  let repaymentDate = oneMonthFromSelectedDay;

  const durationUntilRepayment = moment.duration(oneMonthFromSelectedDay.diff(today));
  const defaultDisabledDays = getDefaultDisabledDays();

  if (defaultDisabledDays.includes(parseInt(selectedDay))) {
    repaymentDate = repaymentDate.date('01').add(1, 'month');
  }

  if (durationUntilRepayment.asDays() < 30) {
    repaymentDate = oneMonthFromSelectedDay.add(1, 'month');
  }

  return repaymentDate;
}

export function getUpperThresholdExclusion(currentDate = moment().format('DD-MM-YYYY')) {
  const today = moment(currentDate, 'DD-MM-YYYY');
  switch (today.format('DD-MM')) {
    case '06-07':
    case '06-12':
      return 1;
    case '28-07':
    case '28-12':
      return 23;
    case '29-07':
    case '29-12':
      return 24;
    case '30-07':
    case '30-12':
      return 25;
    case '31-07':
    case '31-12':
      return 26;
    default:
      return null;
  }
}

/**
 * There are special scenarios when the day is the 1st or second of the month,
 * where we'll disable additional days by default.
 * @param {Number} todayDay
 */
export function getDefaultDisabledDays(currentDate = moment().format('DD-MM-YYYY')) {
  const today = moment(currentDate, 'DD-MM-YYY');
  const todayDay = today.format('DD');
  const thresholdExclusion = getUpperThresholdExclusion(currentDate);
  /**
   * Always disable today, 29th 30th, 31st
   */
  const defaultDays = [...new Set([parseInt(todayDay), 29, 30, 31, thresholdExclusion])].filter(
    (day) => day !== null
  );

  switch (parseInt(todayDay)) {
    case 1: {
      return defaultDays.concat([27, 28]);
    }
    case 2: {
      return defaultDays.concat([28]);
    }
    default: {
      return defaultDays;
    }
  }
}
